
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elearning",
      function () {
        return require("private-next-pages/elearning/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elearning"])
      });
    }
  